import React from 'react'

import { Card, Grid, Box } from '@material-ui/core'
import Restore from '@material-ui/icons/Restore'
import { useDispatch } from 'react-redux'

import styles from '../settingsStyles'

import { deleteTutorials, restoreDashboardWidgets } from '../settingsSlice'
import PageLink from '../components/PageLink'
import BackButtonNavBar from '../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'
import useSettingsBack from '../../../helpers/useSettingsBack'

function AppInfo() {
  const classes = styles()
  const dispatch = useDispatch()
  const goBackButton = useSettingsBack('DashboardSettings', '/settings')
  const user = localStorage.getItem('user') ?? 'visitor'
  const isGuest = user === '"visitor"' || user === ''

  const resetTutorials = () => {
    dispatch(deleteTutorials())
  }

  const handleRestoreDashboardWidgets = () => {
    dispatch(restoreDashboardWidgets())
  }

  return (
    <Box className={classes.settingsNavBar}>
      <BackButtonNavBar
        onClick={goBackButton}
        name="Dashboard Settings"
        topMargin={{ xs: 56, sm: 64, md: 64, lg: 64 }}
      />
      <Box className={classes.centerPage}>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.container}
          wrap="nowrap"
        >
          {!isGuest && (
            <Grid item className={classes.fullWidth}>
              <Card className={classes.linksCard}>
                <PageLink
                  title="Reset Tutorials"
                  description="All tutorials will show again"
                  link={resetTutorials}
                  icon={<Restore />}
                  section="DashboardSettings"
                />
              </Card>
            </Grid>
          )}
          <Grid item className={classes.fullWidth}>
            <Card className={classes.linksCard}>
              <PageLink
                title="Restore Widgets"
                description="Restore dashboard widgets to default"
                link={handleRestoreDashboardWidgets}
                icon={<Restore />}
                section="DashboardSettings"
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default AppInfo
